export const initialAbility = [
  {
    action: 'read',
    subject: 'auth',
  },
  {
    action: 'read',
    subject: 'profile',
  },
]

export const _ = undefined
